import { render, staticRenderFns } from "./off.vue?vue&type=template&id=25e84232&scoped=true&"
import script from "./off.vue?vue&type=script&lang=js&"
export * from "./off.vue?vue&type=script&lang=js&"
import style0 from "./off.vue?vue&type=style&index=0&id=25e84232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e84232",
  null
  
)

export default component.exports